module.exports = __webpack_public_path__ + "static/media/3_03.5178f523.png";